import { useEffect } from "react";

const SITE = "UCare Essentials";
const DEFAULT_TITLE = "UCare Essentials — Ayurvedic Women's Wellness";
const DEFAULT_DESC = "Evidence-based Ayurvedic wellness for women — hormones, periods & hair care. Doctor-reviewed formulations, free shipping above ₹499.";
const DEFAULT_IMAGE = "https://static.prod-images.emergentagent.com/jobs/7948df71-5b8a-401f-96b1-27bdf2734589/images/ca717d0eccffd840526c6af57a9b4edce96a2496e32ac8313deae28377ad0661.jpeg";

function setMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

/** Sets document.title + description + Open Graph/Twitter tags for the current page. */
export default function Seo({ title, description, image }) {
    useEffect(() => {
        const fullTitle = title ? `${title} · ${SITE}` : DEFAULT_TITLE;
        const desc = description || DEFAULT_DESC;
        const img = image || DEFAULT_IMAGE;
        document.title = fullTitle;
        setMeta("name", "description", desc);
        setMeta("property", "og:title", fullTitle);
        setMeta("property", "og:description", desc);
        setMeta("property", "og:image", img);
        setMeta("property", "og:url", window.location.href);
        setMeta("name", "twitter:title", fullTitle);
        setMeta("name", "twitter:description", desc);
        setMeta("name", "twitter:image", img);
    }, [title, description, image]);
    return null;
}
